/**
 * 画面側の型。カードの型は src/lib/cards（docs/spec/card-schema.md §5）、判定は src/lib/judge の再エクスポート。
 * 新しいコードは src/lib/cards を直接 import してよい。
 * 下の GradeState / GradeResult と表示用の定数は docs/design/components.md §0 の UI の型で、lib には無い。
 */
export type {
  Card,
  CardBase,
  CardType,
  Grading,
  PredictOutputCard,
  FillBlankCard,
  ParsonsCard,
  ChoiceCard,
  ReduceCard,
  ComplexityQuizCard,
  WriteAcCard,
  VizStepCard,
  MemoCard,
  DrillCard,
} from '../lib/cards';
export type { Verdict } from '../lib/judge';
export type { Box as LeitnerBox } from '../lib/progress';

import type { Verdict } from '../lib/judge';

// ---- docs/design/components.md §0 ----
export type GradeState = 'idle' | 'answering' | 'grading' | 'graded';

export interface GradeResult {
  verdict: Verdict;
  /** WA/RE/TLE が起きたケース（0 始まり） */
  caseIndex?: number;
  expected?: string;
  actual?: string;
  stderr?: string;
  durationMs?: number;
  /** 判定欄の 1 文目（「出力が一致しました。」など） */
  message?: string;
}

/** カード種別の表示名。正本は src/lib/cards（memo = 暗記を含む） */
export { CARD_TYPE_LABELS } from '../lib/cards';

export const TEXTBOOK_ORIGIN = 'https://swift.inductor.dev';
